import React from 'react';
import styled from 'styled-components';
import CongratulationsLoader from '../../common/GiftLoader/CongratulationsLoader';

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(153, 153, 153, 0.25);
`;


const Congrats = () => (
  <BackDrop>
    <CongratulationsLoader/>
  </BackDrop>
);

export default Congrats;
